import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { ConfiguracionInicialService } from 'src/app/services/configuracioninicial.service';
import { MenuService } from 'src/app/services/menu.service';
import { UtilitariosService } from 'src/app/services/utilitarios.service';
import { ConfiguracionService } from '../../services/configuracion.service';
import { RespuestaGenerica } from '../../models/generic/RespuestaGenerica';
import { ConfirmacionGenericaComponent } from '../confirmaciongenerica/confirmaciongenerica.component';
import { TamanoAppService } from 'src/app/services/tamanoapp.service';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import { Maestros_UsuariosService } from '../../services/maestros_usuarios.service';
import { Maestro_Usuarios_Roles_Canales } from 'src/app/models/generic/Maestro_Usuarios_Roles_Canales';
import { Maestro_Usuarios } from '../../models/generic/Maestro_Usuarios';
import { Maestro_Usuarios_Actualizacion } from 'src/app/models/generic/Maestro_Usuarios_Actualizacion';
import { Maestro_EstadoActualizar } from 'src/app/models/generic/Maestro_EstadoActualizar';
import { Maestro_Roles } from 'src/app/models/generic/Maestro_Roles';
import { Maestro_Provincias } from 'src/app/models/generic/Maestro_Provincias';
import { Maestro_Ciudades } from 'src/app/models/generic/Maestro_Ciudades';
import { Maestros_ProvinciasService } from 'src/app/services/maestros_provincias';
import { Maestros_RolesService } from 'src/app/services/maestros_roles';
import { Maestros_CiudadesService } from 'src/app/services/maestros_ciudades';
import { Maestro_Usuarios_IpsAutorizadas } from 'src/app/models/generic/Maestro_Usuarios_IpsAutorizadas';

@Component({
  selector: 'maestros-usuarios-editar',
  templateUrl: './maestros-usuarios-editar.component.html',
  styleUrls: ['./maestros-usuarios-editar.component.scss']
})
export class MaestrosUsuariosEditarComponent implements OnInit{
  
  form: FormGroup;
  formIpsAutorizadas: FormGroup;
  formConsulta: FormGroup;
  tituloForma: string = 'Registro de usuarios';
  tituloBoton: string = 'Registrar usuarios';
  mostrarCargando: boolean = false;
  codigoAccion: string = '';
  @ViewChild('appconfirmacion', {static: false}) _appconfirmacion: ConfirmacionGenericaComponent;
  idTabSeleccionado: number = 0;

  detalleSeleccionado: number;
  detalleSeleccionadoIpsAutorizadas: number;
  editarRegistroIpsAutorizadas: boolean = false;
  @ViewChild('paginatorroles') paginator: MatPaginator;
  @ViewChild('paginatoripsautorizadas') paginatoripsautorizadas: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatSort) sortipsautorizadas: MatSort;
  dataSourceRolesCanal: MatTableDataSource<Maestro_Usuarios_Roles_Canales>;
  dataSourceIpsAutorizadas: MatTableDataSource<Maestro_Usuarios_IpsAutorizadas>;
  columnasEncabezadoRolesCanal: string[] = ['aliado', 'canal', 'rol', 'seleccionado'];
  columnasEncabezadoIpsAutorizadas: string[] = ['ip', 'acciones'];
  listaDatosRolesCanal: Maestro_Usuarios_Roles_Canales[] = [];
  listaDatosIpsAutorizadas: Maestro_Usuarios_IpsAutorizadas[] = [];
  listaDatosIpsAutorizadasEliminar: Maestro_Usuarios_IpsAutorizadas[] = [];
  tabItemSeleccionadoAnterior: string = '';
  tabItemSeleccionado: string = 'tabInformacion';
  parametrosPrincipal: Maestro_Usuarios;
  seleccionarTodos: boolean = false;
  ejecutarSeleccionarTodos: boolean = true;
  listaEstado: Maestro_EstadoActualizar[] = [];
  listaRoles: Maestro_Roles[] = [];
  listaProvincias: Maestro_Provincias[] = [];
  listaCiudades: Maestro_Ciudades[] = [];
  listaCiudadesEdicion: Maestro_Ciudades[] = [];
  
  constructor(public router: Router,
    public fb: FormBuilder,
    public cd: ChangeDetectorRef,
    public snackbar: MatSnackBar,
    public utilitariosService: UtilitariosService,
    public configuracionInicialService: ConfiguracionInicialService,
    public menuService: MenuService,
    public datosServices: Maestros_UsuariosService,
    public configuracionService: ConfiguracionService,
    public tamanoAppService: TamanoAppService,
    public provinciasService: Maestros_ProvinciasService,
    public rolesServices: Maestros_RolesService,
    public ciudadesServices: Maestros_CiudadesService) {}

  ngOnInit() {
    this.IniciarFormulario();
    this.listaEstado = [];
    this.listaEstado.push({ seleccionado: true, descripcion: 'Si' });
    this.listaEstado.push({ seleccionado: false, descripcion: 'No' });

    this.ConsultarRoles();
    this.ConsultarProvincias();
    this.ConsultarCiudades();
  }
  ngAfterViewInit() {
    this.utilitariosService.EstablecerTextoPaginado(this.paginator);
    
    if (this.utilitariosService.VerificarContieneDatos(this.menuService.ParametrosAdicionales)) {
      this.parametrosPrincipal = JSON.parse(this.menuService.ParametrosAdicionales);

      // console.log('setea valor', this.parametrosPrincipal);
      this.form.setValue(this.parametrosPrincipal);
      
      this.tituloForma = 'Edición de usuarios';
      this.tituloBoton = 'Editar usuario';
    } else {
      this.tituloForma = 'Registro de usuarios';
      this.tituloBoton = 'Registrar usuario';
      this.parametrosPrincipal = new Maestro_Usuarios();
      this.parametrosPrincipal.id = 0;
    }

    this.ConsultarRegistrosRolesCanal();
    this.ConsultarRegistrosIpsAutorizadas();
  }

  IniciarFormulario() {
    this.form = this.fb.group({
      id: [0],
      login: ['', [Validators.required, Validators.maxLength(30)]],
      nroDocumento: ['', [Validators.required, Validators.maxLength(20)]],
      nombre: ['', [Validators.required, Validators.maxLength(100)]],
      apellidos: ['', [Validators.required, Validators.maxLength(100)]],
      nombresApellidos: [''],
      email: ['', [Validators.required, Validators.maxLength(100), Validators.email]],
      movil: ['', [Validators.required, Validators.maxLength(100)]],
      domicilio: ['', [Validators.maxLength(100)]],
      provincia: ['', [Validators.required]],
      provinciaDescripcion: [''],
      ciudad: ['', [Validators.required]],
      ciudadDescripcion: [''],
      activo: [true],
      idRol: [0, [Validators.required, Validators.min(1)]],
      rol: [''],
      mostrarRolesAliado: [false]
    });

    this.form.get('provincia').valueChanges.subscribe((valorNuevo) => {
      this.CiudadesProvincia(valorNuevo);
    });
    this.form.get('idRol').valueChanges.subscribe((valorNuevo) => {
      let rolSeleccionado = this.listaRoles.filter(x => x.id === valorNuevo);
      if (rolSeleccionado.length > 0) {
        this.form.get('mostrarRolesAliado').setValue(rolSeleccionado[0].mostrarAliado);
        if (rolSeleccionado[0].mostrarAliado) {
          this.ConsultarRegistrosRolesCanal();
        }
      }
    });

    this.formConsulta = this.fb.group({
      idAliado: [0],
      idCanal: [0]
    });

    this.formConsulta.get('idAliado').valueChanges.subscribe((valorNuevo) => {
      
    });
  }
  CancelarRegistro() {
    this.menuService.CambiarComponenteActivo('MaestrosUsuariosComponent');
  }
  Guardar() {
    if (this.form.valid) {
      this.codigoAccion = 'guardar';
      this._appconfirmacion.MostrarMensajeConfirmacion();
    } else {
      this.utilitariosService.MostrarErroresFormulario(this.form);
    }
  }
  ConfirmoUsuario(confirmo: boolean) {
    if (confirmo) {
      if (this.codigoAccion === 'guardar') {
        this.ActualizarRegistro();
      } else if (this.codigoAccion === 'eliminarIpsAutorizadas') {
        this.EliminarRegistroIpsAutorizadas();
      }
    }
  }
  ActualizarRegistro() {
    this.mostrarCargando = true;
    
    let parametrosActualizacion: Maestro_Usuarios_Actualizacion = new Maestro_Usuarios_Actualizacion();
    parametrosActualizacion.principal = new Maestro_Usuarios();
    parametrosActualizacion.principal.id = this.form.get('id').value;
    parametrosActualizacion.principal.login = this.form.get('login').value;
    parametrosActualizacion.principal.nroDocumento = this.form.get('nroDocumento').value;
    parametrosActualizacion.principal.nombre = this.form.get('nombre').value;
    parametrosActualizacion.principal.apellidos = this.form.get('apellidos').value;
    parametrosActualizacion.principal.nombresApellidos = this.form.get('nombresApellidos').value;
    parametrosActualizacion.principal.email = this.form.get('email').value;
    parametrosActualizacion.principal.movil = this.form.get('movil').value;
    parametrosActualizacion.principal.domicilio = this.form.get('domicilio').value;
    parametrosActualizacion.principal.provincia = this.form.get('provincia').value;
    parametrosActualizacion.principal.provinciaDescripcion = this.form.get('provinciaDescripcion').value;
    parametrosActualizacion.principal.ciudad = this.form.get('ciudad').value;
    parametrosActualizacion.principal.ciudadDescripcion = this.form.get('ciudadDescripcion').value;
    parametrosActualizacion.principal.activo = this.form.get('activo').value;
    parametrosActualizacion.principal.idRol = this.form.get('idRol').value;
    parametrosActualizacion.principal.rol = this.form.get('rol').value;
    parametrosActualizacion.principal.mostrarRolesAliado = this.form.get('mostrarRolesAliado').value;
    parametrosActualizacion.listaRoles = this.dataSourceRolesCanal.data;
    parametrosActualizacion.listaIpsAutorizadas = this.listaDatosIpsAutorizadas;
    parametrosActualizacion.listaIpsAutorizadasEliminar = this.listaDatosIpsAutorizadasEliminar;

    this.datosServices.Actualizar(parametrosActualizacion)
            .subscribe((resp: RespuestaGenerica) =>{
              this.mostrarCargando = false;
              if (resp.procesoExitoso == false) {
                this.utilitariosService.MensajeToast(resp.mensaje);
              } else {
                this.menuService.CambiarComponenteActivo('MaestrosUsuariosComponent');
              }
            },
            (error: Error) => {
              this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
              this.mostrarCargando = false;
              this.cd.detectChanges();
            },
            () => this.cd.detectChanges());
  }
  ConsultarRegistrosRolesCanal() {
    this.mostrarCargando = true;
    this.datosServices.Aliados_Canales_Consultar(this.parametrosPrincipal.id)
              .subscribe((resp: Maestro_Usuarios_Roles_Canales[]) =>{
                this.mostrarCargando = false;
                this.listaDatosRolesCanal = resp;
                this.recargarListaRolesCanal();
              },
              (error: Error) => {
                this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                this.mostrarCargando = false;
                this.cd.detectChanges();
              },
              () => this.cd.detectChanges());
  }
  ConsultarRegistrosIpsAutorizadas() {
    this.mostrarCargando = true;
    let parametrosConsulta = this.fb.group({
      id: [0]
    });

    parametrosConsulta.get('id').setValue(this.parametrosPrincipal.id);
    
    this.datosServices.IpsAutorizadas_Consultar(parametrosConsulta.value)
              .subscribe((resp: Maestro_Usuarios_IpsAutorizadas[]) =>{
                this.mostrarCargando = false;
                this.listaDatosIpsAutorizadas = resp;
                this.recargarListaIpsAutorizadas();
              },
              (error: Error) => {
                this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                this.mostrarCargando = false;
                this.cd.detectChanges();
              },
              () => this.cd.detectChanges());
  }
  tabSeleccionado(item: any) {
    this.idTabSeleccionado = item.index;    
    this.tabItemSeleccionadoAnterior = this.tabItemSeleccionado;
    this.tabItemSeleccionado = item.tab.textLabel;
    
    if (this.tabItemSeleccionado === 'tabRoles') {
      this.recargarListaRolesCanal();
    }
    else if (this.tabItemSeleccionado === 'tabIpsAutorizadas') {
      this.recargarListaIpsAutorizadas();
    }
  }

  recargarListaRolesCanal() {
    this.dataSourceRolesCanal = new MatTableDataSource(this.listaDatosRolesCanal);
    this.dataSourceRolesCanal.paginator = this.paginator;
    this.dataSourceRolesCanal.sort = this.sort;
    this.VerificarSeleccionarTodos();
  }
  VerificarSeleccionarTodos() {
    this.ejecutarSeleccionarTodos = false;
    if (this.listaDatosRolesCanal.length === this.listaDatosRolesCanal.filter(x => x.seleccionado).length) {
      this.seleccionarTodos = true;
    } else {
      this.seleccionarTodos = false;
    }
    this.ejecutarSeleccionarTodos = true;
  }
  SeleccionoTodos() {
    if (this.ejecutarSeleccionarTodos) {
      for (let index = 0; index < this.listaDatosRolesCanal.length; index++) {
        this.listaDatosRolesCanal[index].seleccionado = this.seleccionarTodos;
      }
    }
  }
  ConsultarRoles() {
    this.mostrarCargando = true;
    let parametroConsulta = this.fb.group({
      filtro: ['']
    });
    this.rolesServices.Consultar(parametroConsulta.value)
            .subscribe((resp: Maestro_Roles[]) =>{
              this.listaRoles = resp;
              this.ConsultarProvincias();
            },
            (error: Error) => {
              this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
              this.mostrarCargando = false;
              this.cd.detectChanges();
            },
            () => this.cd.detectChanges());
  }
  ConsultarProvincias() {
    let parametroConsulta = this.fb.group({
      filtro: ['']
    });
    this.provinciasService.Consultar(parametroConsulta.value)
            .subscribe((resp: Maestro_Provincias[]) =>{
              this.listaProvincias = resp;
              this.ConsultarCiudades();
            },
            (error: Error) => {
              this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
              this.mostrarCargando = false;
              this.cd.detectChanges();
            },
            () => this.cd.detectChanges());
  }
  ConsultarCiudades() {
    let parametroConsulta = this.fb.group({
      filtro: ['']
    });
    this.ciudadesServices.Consultar(parametroConsulta.value)
            .subscribe((resp: Maestro_Ciudades[]) =>{
              this.listaCiudades = resp;
              this.mostrarCargando = false;

              if (this.utilitariosService.VerificarContieneDatosTexto(this.form.get('provincia').value)) {
                this.CiudadesProvincia(this.form.get('provincia').value);
              }
            },
            (error: Error) => {
              this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
              this.mostrarCargando = false;
              this.cd.detectChanges();
            },
            () => this.cd.detectChanges());
  }
  CiudadesProvincia(provincia: string) {
    this.listaCiudadesEdicion = this.listaCiudades.filter(x => x.provincia === provincia);
  }
  //campos ipsautorizadas
  IniciarFormularioCamposIpsAutorizadas() {
    this.formIpsAutorizadas = this.fb.group({
      'id': new FormControl(0),
      'ipPublica': new FormControl('', [Validators.required, Validators.maxLength(20)]),
    });
  }
  recargarListaIpsAutorizadas() {
    this.dataSourceIpsAutorizadas = new MatTableDataSource(this.listaDatosIpsAutorizadas);
    setTimeout(() => {
      this.dataSourceIpsAutorizadas.paginator = this.paginatoripsautorizadas;
      this.dataSourceIpsAutorizadas.sort = this.sortipsautorizadas;
    });
  }
  NuevoIpsAutorizadas() {
    this.editarRegistroIpsAutorizadas = true;
    this.IniciarFormularioCamposIpsAutorizadas();
    this.formIpsAutorizadas.get('id').setValue((this.listaDatosIpsAutorizadas.length + 1) * -1);
  }
  EditarIpsAutorizadas(camposEditar: Maestro_Usuarios_IpsAutorizadas) {
    this.editarRegistroIpsAutorizadas = true;
    this.IniciarFormularioCamposIpsAutorizadas();
    this.formIpsAutorizadas.setValue(camposEditar);
  }
  EliminarIpsAutorizadas(CamposEditar: Maestro_Usuarios_IpsAutorizadas) {
    this.detalleSeleccionadoIpsAutorizadas = CamposEditar.id;
    this.codigoAccion = 'eliminarIpsAutorizadas';
    this._appconfirmacion.MostrarMensajeConfirmacion();
  }
  GuardarIpsAutorizadas() {
    if (this.formIpsAutorizadas.valid) {
      this.editarRegistroIpsAutorizadas = false;
      if (this.listaDatosIpsAutorizadas.filter(x => x.id === this.formIpsAutorizadas.get('id').value).length > 0) {
        let parametroActualizar = this.listaDatosIpsAutorizadas.filter(x => x.id === this.formIpsAutorizadas.get('id').value)[0];
        parametroActualizar.ipPublica = this.formIpsAutorizadas.get('ipPublica').value;
      } else {
        this.listaDatosIpsAutorizadas.push(this.formIpsAutorizadas.value);
      }
      
      this.recargarListaIpsAutorizadas();
    } else {
      this.utilitariosService.MostrarErroresFormulario(this.formIpsAutorizadas);
    }
  }
  CancelarEditarIpsAutorizadas() {
    this.editarRegistroIpsAutorizadas = false;
  }
  EliminarRegistroIpsAutorizadas() {
    if (this.detalleSeleccionadoIpsAutorizadas > 0) {
      this.listaDatosIpsAutorizadasEliminar.push(this.listaDatosIpsAutorizadas.filter(x => x.id === this.detalleSeleccionadoIpsAutorizadas)[0]);
    }
    let listaNueva: Maestro_Usuarios_IpsAutorizadas[] = [];
    for (let index = 0; index < this.listaDatosIpsAutorizadas.length; index++) {
      if (this.listaDatosIpsAutorizadas[index].id !== this.detalleSeleccionadoIpsAutorizadas) {
        listaNueva.push(this.listaDatosIpsAutorizadas[index]);
      }
    }
    this.listaDatosIpsAutorizadas = listaNueva;
    this.recargarListaIpsAutorizadas();
  }
}
